// extracted by mini-css-extract-plugin
export default {"page":"FormulationPage_page__ptH0P"};